class DupattaToggle extends HTMLElement {
  #controller;
  async connectedCallback() {
    this.#controller?.abort();
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    await customElements.whenDefined('variant-picker');
    if (signal.aborted || !this.isConnected) return;
    const scope = this.closest('dialog') || this.closest('.shopify-section');
    const picker = Array.from(scope?.querySelectorAll('variant-picker') || []).find(p => p.dataset.productId === this.dataset.productId);
    const checkbox = this.querySelector('[data-dupatta-checkbox]');
    const getSet = () => picker?.querySelector('[data-dupatta-set]');
    if (!picker || !checkbox || !getSet()) { this.hidden = true; return; }
    const selectValue = (value) => {
      const radio = Array.from(getSet().querySelectorAll('input[type="radio"]')).find(input => input.value === value);
      if (radio) { radio.click(); return true; }
      const select = getSet().querySelector('select');
      if (select && Array.from(select.options).some(option => option.value === value)) {
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
      return false;
    };
    const currentValue = () => getSet().querySelector('input:checked')?.value || getSet().querySelector('select')?.value;
    const status = this.querySelector('[data-dupatta-status]');
    picker.dataset.dupattaEnhanced = 'true';
    checkbox.addEventListener('change', () => {
      const value = checkbox.checked ? this.dataset.premium : this.dataset.base;
      if (!selectValue(value)) { checkbox.checked = currentValue() === this.dataset.premium; }
    }, { signal });
    picker.addEventListener('change', () => {
      checkbox.disabled = true;
      this.setAttribute('aria-busy', 'true');
      status.textContent = '';
    }, { signal });
    picker.addEventListener('dupatta:rendered', event => {
      const html = event.detail.html;
      const updated = Array.from(html.querySelectorAll('dupatta-toggle')).find(el => el.dataset.sectionId === this.dataset.sectionId && el.dataset.productId === this.dataset.productId);
      if (!updated) { this.hidden = true; return; }
      this.dataset.selected = updated.dataset.selected;
      picker.dataset.dupattaEnhanced = 'true';
      checkbox.checked = updated.dataset.selected === this.dataset.premium;
      checkbox.disabled = false;
      this.removeAttribute('aria-busy');
      this.querySelector('[data-dupatta-surcharge]').textContent = updated.querySelector('[data-dupatta-surcharge]').textContent;
      const price = scope.querySelector('[data-dupatta-price]');
      const updatedPrice = Array.from(html.querySelectorAll('[data-dupatta-price]')).find(el => el.dataset.sectionId === this.dataset.sectionId);
      if (price && updatedPrice) price.innerHTML = updatedPrice.innerHTML;
    }, { signal });
    picker.addEventListener('dupatta:failed', () => {
      checkbox.disabled = false;
      checkbox.checked = this.dataset.selected === this.dataset.premium;
      this.removeAttribute('aria-busy');
      status.textContent = this.querySelector('[data-dupatta-error]').textContent;
      delete picker.dataset.dupattaEnhanced;
    }, { signal });
    const url = new URL(window.location.href);
    if (!url.searchParams.has('variant') && !url.searchParams.has('option_values') && currentValue() !== this.dataset.base) {
      selectValue(this.dataset.base);
    }
  }
  disconnectedCallback() { this.#controller?.abort(); }
}
if (!customElements.get('dupatta-toggle')) customElements.define('dupatta-toggle', DupattaToggle);
